import React from 'react';
import { Modal } from '@lifeomic/chroma-react/components/Modal';
import { Button } from '@lifeomic/chroma-react/components/Button';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  modalTitle: {
    id: 'UnsavedConfirmationModal.title',
    defaultMessage: 'Unsaved Changes',
  },
  modalMessage: {
    id: 'UnsavedConfirmationModal.message',
    defaultMessage:
      'You have unsaved changes that will be lost if you continue. Do you want to discard your changes?',
  },
  confirmButton: {
    id: 'UnsavedConfirmationModal.confirm',
    defaultMessage: 'Discard Changes',
  },
  cancelButton: {
    id: 'UnsavedConfirmationModal.cancel',
    defaultMessage: 'Keep Editing',
  },
});

const useStyles = makeStyles(theme => ({
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
  message: {
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.body1.lineHeight,
    color: theme.palette.text.primary,
  },
}));

type UnsavedConfirmationModalProps = {
  isOpen: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
};

export const UnsavedConfirmationModal: React.FC<
  UnsavedConfirmationModalProps
> = ({ isOpen, onDismiss, onConfirm }) => {
  const styles = useStyles();
  const { formatMessage } = useIntl();

  return (
    <Modal
      isOpen={isOpen}
      onDismiss={onDismiss}
      size={1}
      title={formatMessage(messages.modalTitle)}
      actions={
        <>
          <Button variant="text" color="negative" onClick={onDismiss}>
            {formatMessage(messages.cancelButton)}
          </Button>
          <Button variant="contained" onClick={onConfirm}>
            {formatMessage(messages.confirmButton)}
          </Button>
        </>
      }
    >
      <div className={styles.modalContent}>
        <div className={styles.message}>
          {formatMessage(messages.modalMessage)}
        </div>
      </div>
    </Modal>
  );
};
